import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TrailerStatus } from 'src/app/types';
import { TrailersService } from '../trailers.service';

@Component({
  selector: 'lohi-company-trailers',
  templateUrl: './company-trailers.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyTrailersComponent implements OnInit {
  public trailerStatus$: Observable<TrailerStatus>;

  constructor(private trailerService: TrailersService) {}

  public ngOnInit(): void {
    this.trailerStatus$ = this.trailerService.trailerStatus$;
  }
}
